// extracted by mini-css-extract-plugin
export default {"item":"DropDownCourseItem_item__aT5FT"};